/* Barra de compra flotante — Gradivus
   Antes dependia de tres cosas seguidas (el form por id, un boton con
   data-add-to-cart adentro, y un IntersectionObserver sobre ese boton). Si
   fallaba cualquiera, la barra no aparecia y no avisaba. Ahora cada paso tiene
   plan B, el disparo es por scroll y, si no encuentra el boton principal,
   aparece igual pasado un umbral. */
(function () {
  var UMBRAL = 600; // px de scroll para mostrarla cuando no hay boton de referencia

  function money(cents) {
    if (window.theme && theme.Currency && theme.Currency.formatMoney) {
      return theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
    }
    return '$' + Math.round(cents / 100).toLocaleString('es-CL');
  }

  function buscarForm(bar) {
    var id = bar.dataset.formId;
    var form = id ? document.getElementById(id) : null;
    if (form) return form;

    // Plan B: el form de agregar al carro de la ficha principal
    var candidatos = document.querySelectorAll('form[action*="/cart/add"]');
    for (var i = 0; i < candidatos.length; i++) {
      if (candidatos[i].closest('[data-section-type="product"], .product-section, main')) {
        return candidatos[i];
      }
    }
    return candidatos[0] || null;
  }

  function buscarPrincipal(form) {
    if (!form) return null;
    return form.querySelector('[data-add-to-cart]')
      || form.querySelector('button[name="add"]')
      || form.querySelector('.add-to-cart')
      || document.querySelector('[data-add-to-cart]')
      || null;
  }

  function init(bar) {
    if (bar.dataset.listo === 'true') return;
    bar.dataset.listo = 'true';

    var form = buscarForm(bar);
    var principal = buscarPrincipal(form);

    if (!form) console.warn('[sticky-atc] no encontre el form de compra; la barra igual aparece por scroll.');
    if (!principal) console.warn('[sticky-atc] no encontre el boton de agregar al carro; disparo por umbral de scroll.');

    // Un position:fixed dentro de un ancestro con transform deja de ser fijo.
    // Se mueve al final del body para que siempre quede pegada a la pantalla.
    if (bar.parentNode !== document.body) document.body.appendChild(bar);

    var comprar = bar.querySelector('[data-sticky-comprar]');
    var carro = bar.querySelector('[data-sticky-carro]') || bar.querySelector('.sticky-atc__carro');
    var precio = bar.querySelector('[data-sticky-price]');
    var compara = bar.querySelector('[data-sticky-compare]');
    var variante = bar.querySelector('[data-sticky-variante]');
    var imagen = bar.querySelector('[data-sticky-image]');

    // Si el form quedo fuera del boton del carro (o no hay form), el submit por
    // atributo form="" no sirve: se esconde ese boton y queda solo Comprar.
    if (carro && (!form || !form.id || document.getElementById(form.id) !== form)) {
      carro.hidden = true;
    } else if (carro && form && form.id) {
      carro.setAttribute('form', form.id);
    }

    var visible = null;
    function mostrar(si) {
      if (si === visible) return;
      visible = si;
      bar.classList.toggle('is-visible', si);
      document.body.classList.toggle('sticky-atc-active', si);
    }

    function evaluar() {
      if (principal) {
        var caja = principal.getBoundingClientRect();
        var tieneLayout = caja.width > 0 || caja.height > 0;
        if (tieneLayout) {
          // Aparece cuando el boton grande empieza a salir por arriba, no
          // cuando ya se fue del todo: asi acompaña desde que pasas las tallas.
          mostrar(caja.top < 0);
          return;
        }
      }
      // sin boton de referencia visible: umbral de scroll
      mostrar((window.pageYOffset || document.documentElement.scrollTop) > UMBRAL);
    }

    var pendiente = false;
    function agendar() {
      if (pendiente) return;
      pendiente = true;
      window.requestAnimationFrame(function () {
        pendiente = false;
        evaluar();
      });
    }

    window.addEventListener('scroll', agendar, { passive: true });
    window.addEventListener('resize', agendar);
    window.addEventListener('orientationchange', agendar);
    evaluar();

    // El id de la variante viaja en el DOM. El <select name="id"> del tema no
    // sirve de fuente: las variantes agotadas se pintan como <option disabled>
    // SIN atributo value, asi que masterSelect.value = id falla en silencio y el
    // select se queda apuntando a la variante anterior.
    var variantId = bar.dataset.variantId || '';

    // Los accesorios marcados en "Completa tu equipo" viajan con la barra:
    // si alguien marca vendas y compra desde aca, no se pierden en silencio.
    function extras() {
      if (!window.FilmeezyAddons || !window.FilmeezyAddons.seleccionados) return [];
      try { return window.FilmeezyAddons.seleccionados(); } catch (e) { return []; }
    }

    function cantidad() {
      var cant = form && form.querySelector('[name="quantity"]');
      return parseInt(cant && cant.value, 10) || 1;
    }

    // El estado del boton grande manda: si el tema lo deshabilito, la barra
    // tiene que decir lo mismo, aunque nunca se dispare variant:change.
    function sincronizar() {
      if (!principal || !comprar) return;
      var bloqueado = principal.disabled || principal.hasAttribute('disabled');
      comprar.disabled = bloqueado;
      if (carro) carro.disabled = bloqueado;
      comprar.textContent = bloqueado ? bar.dataset.soldOutText : bar.dataset.comprarText;
    }

    sincronizar();

    if (principal && 'MutationObserver' in window) {
      new MutationObserver(sincronizar).observe(principal, {
        attributes: true,
        attributeFilter: ['disabled']
      });
    }

    // Comprar ahora: agrega y salta al checkout
    if (comprar) {
      comprar.addEventListener('click', function () {
        var sel = form && form.querySelector('[name="id"]');
        var id = variantId || (sel && sel.value) || '';

        if (!id) {
          console.warn('[sticky-atc] sin id de variante; mando el form completo.');
          if (form) { form.requestSubmit ? form.requestSubmit() : form.submit(); }
          return;
        }

        var qty = cantidad();
        comprar.disabled = true;
        comprar.classList.add('is-cargando');

        var payload = [{ id: id, quantity: qty }].concat(extras());

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: payload })
        })
          .then(function (r) {
            if (!r.ok) throw new Error('add ' + r.status);
            window.location.href = '/checkout';
          })
          .catch(function (e) {
            console.warn('[sticky-atc] /cart/add.js fallo, uso el permalink del carro.', e);
            // Permalink de Shopify: agrega y lleva al carro. Nunca se queda mudo.
            window.location.href = '/cart/' + id + ':' + qty;
          });
      });
    }

    // Agregar al carro sin salir de la ficha: el tema arma el carrito con
    // 'cart:build' y abre el cajon con 'cart:open'. Si no hay cajon, va a /cart.
    if (carro) {
      carro.addEventListener('click', function (evt) {
        var id = variantId || '';
        if (!id) return; // sin id, deja pasar el submit nativo del form

        evt.preventDefault();
        var qty = cantidad();
        carro.disabled = true;
        carro.classList.add('is-cargando');

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: id, quantity: qty }].concat(extras()) })
        })
          .then(function (r) {
            if (!r.ok) throw new Error('add ' + r.status);
            if (window.FilmeezyAddons) window.FilmeezyAddons.limpiar();
            carro.disabled = false;
            carro.classList.remove('is-cargando');

            if (document.querySelector('#CartDrawer')) {
              document.dispatchEvent(new CustomEvent('cart:build'));
              document.dispatchEvent(new CustomEvent('cart:open'));
            } else {
              window.location.href = '/cart';
            }
          })
          .catch(function (e) {
            console.warn('[sticky-atc] no pude agregar por AJAX, voy al carro.', e);
            window.location.href = '/cart/' + id + ':' + qty;
          });
      });
    }

    document.addEventListener('variant:change', function (evt) {
      var v = evt.detail && evt.detail.variant;
      if (!comprar) return;

      if (!v) {
        comprar.disabled = true;
        comprar.textContent = bar.dataset.soldOutText;
        if (carro) carro.disabled = true;
        return;
      }
      variantId = String(v.id);
      comprar.disabled = !v.available;
      if (carro) carro.disabled = !v.available;
      comprar.textContent = v.available ? bar.dataset.comprarText : bar.dataset.soldOutText;
      // CyberGradivus: precio con descuento y el de antes tachado
      var vPrecio = theme.cyberPrecio ? theme.cyberPrecio(v.price) : v.price;
      var vAntes = theme.cyberAntes ? theme.cyberAntes(v.price, v.compare_at_price) : v.compare_at_price;
      if (precio) precio.innerHTML = money(vPrecio);
      if (variante) {
        var opciones = (v.options || []).filter(function (o) { return o && o !== 'Default Title'; });
        variante.textContent = opciones.length ? opciones.join(' · ') : '';
      }
      if (compara) {
        var hay = vAntes && vAntes > vPrecio;
        if (hay) compara.innerHTML = money(vAntes);
        compara.hidden = !hay;
      }
      if (imagen && v.featured_image && v.featured_image.src) imagen.src = v.featured_image.src;
    });
  }

  function initAll() { document.querySelectorAll('[data-sticky-atc]').forEach(init); }

  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', initAll);
  window.addEventListener('load', initAll);
  document.addEventListener('shopify:section:load', initAll);
})();
